import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    showSplitView: false,
    report: "",
    targetCaption: "",
    period: "",
    amountCol: "",
    reportName: "",
    editedCaptions: "",
    cfsLib: "",
    data: "",
    fileType:"",
    upLoadedExcelsData:null,
    isCameThroughHyperLink:false,
    cameFromReportName:null,
    clickedRowData:[],
    glData: null,
    selectedEntry: null,
    journalData: null,
    activeFilter: {},
    cfsWpUniqueEntry: {
        cfsIndirectRows: "",
        cfsDirectRows: "",
        cfsEntriesMethod: "",
        selectedSplitedEntryId: "",
        uploadedPeriods: ""
    },
    selectedSplitedEntryIdInner: "",
    uploadedExcelFilesChecksState : {
        uploadedRawData:null, 
        period:null,
        journalData:null,
        formState:null,
        glData:null 
    }
}

const splitView = createSlice({
    name: 'SPLITVIEWSLICE',
    initialState,
    reducers: {
        showSplitViewHandler(state, action) {
            state.showSplitView = action?.payload?.showSplitView || false;
            state.report = action?.payload?.report || "";
            state.targetCaption = action?.payload?.targetCaption || "";
            state.period = action?.payload?.period || "";
            state.amountCol = action?.payload?.amountCol || "";
            state.reportName = action?.payload?.reportName || "";
            state.editedCaptions = action?.payload?.editedCaptions || "";
            state.cfsLib = action?.payload?.cfsLib || "";
            state.data = action?.payload?.data || "";
            state.fileType = action?.payload?.fileType || "";
            state.isCameThroughHyperLink = false;
            state.clickedRowData = [];
            state.cfsWpUniqueEntry = action?.payload?.cfsWpUniqueEntry || {}
            state.glData = action?.payload?.glData;
            state.selectedEntry = action?.payload?.selectedEntry;
            state.journalData = action?.payload?.journalData;
            state.selectedSplitedEntryIdInner = action?.payload?.selectedSplitedEntryIdInner || "";
            state.activeFilter = action?.payload?.activeFilter;
        },
        closeSplitViewHandler(state) {
            return {...initialState, upLoadedExcelsData:state.upLoadedExcelsData, uploadedExcelFilesChecksState: state.uploadedExcelFilesChecksState  };
        },
        setUpLoadedExcelsData(state, action) {
            state.upLoadedExcelsData = action?.payload?.upLoadedExcelsData || null
        },
        setIsCameThroughHyperLink(state, action) {
            // console.log("action",action?.payload)
            state.isCameThroughHyperLink = action?.payload?.isCameThroughHyperLink ?? false;
            state.clickedRowData = action?.payload?.clickedRowData ?? [];
            state.fileType = action?.payload?.fileType ?? "";
            if (action?.payload?.cameFromReportName) {
                state.cameFromReportName = action?.payload?.cameFromReportName
                state.report = action?.payload?.report;
            }
        },
        clearFileType(state) {
            state.fileType = null;
        },
        setUpLoadedExcelFilesCheckState(state, action) {
            state.uploadedExcelFilesChecksState = action?.payload;
            state.report = "quckbook-excel-checks";
            state.showSplitView = true;
            state.period = action?.payload?.period;
        },
        clearUpLoadedExcelFilesCheckState(state,) {
            state.uploadedExcelFilesChecksState = {
                uploadedRawData: null,
                period: null,
                journalData: null,
                formState: null,
                glData: null
            };
            state.showSplitView = false
            state.report = "";
        }
    }
});

export const { showSplitViewHandler, setUpLoadedExcelsData, setIsCameThroughHyperLink, setUpLoadedExcelFilesCheckState, clearUpLoadedExcelFilesCheckState, clearFileType, closeSplitViewHandler } = splitView.actions

export default splitView;